import { SaleOrder } from '@/domain/SaleOrder';
import { Services } from '@/infra/services';

import { baseSaleOrderAdapter } from './adapter';

const ORDERS_PER_PAGE = 10;

export async function getSaleOrders() {
  const response = await Services.SaleOrder.getSaleOrders({
    perPage: ORDERS_PER_PAGE,
  });

  return response.data.map((saleOrder) => {
    const domainProps = baseSaleOrderAdapter(saleOrder);

    return new SaleOrder(domainProps);
  });
}
